import React from 'react';

export interface IFeature {
  title: string;
  icon: string;
  content: string;
}

interface IProps {
  feature: Array<IFeature>;
}

export class FeatureBlock extends React.Component<IProps> {
  render() {
    return (
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <div className="story-block story-left">
            <div className="story-text">
              <h4>{this.props.feature[0].title}</h4>
              <p>{this.props.feature[0].content}</p>
            </div>
            <div className="story-image">
              <img src={this.props.feature[0].icon} alt="theme_library" />
            </div>
            <span className="story-arrow"></span>
            <span className="h-line"></span>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="story-block story-right">
            <div className="story-text">
              <h4>{this.props.feature[1].title}</h4>
              <p>{this.props.feature[1].content}</p>
            </div>
            <div className="story-image">
              <img src={this.props.feature[1].icon} alt="picture_library" />
            </div>
            <span className="story-arrow"></span>
          </div>
        </div>
      </div>
    );
  }
}
